<template>

  <form id="manufacturerForm" class="mx-auto col-sm-8" @submit.prevent>

    <div class="form-group" :class="{ 'has-error': errors.has('manufacturer') }">
      <label for="manufacturer">{{ $t('manufacturer') }}</label>
        <input
          type="text"
          id="manufacturer"
          name="manufacturer"
          class="form-control"
          :placeholder="$t('ph_manufacturer')"
          v-model="manufacturer.name"
          v-validate="'required'"
          @input="manufacturer.name = manufacturer.name.toUpperCase()"
        >
      <small v-show="errors.has('manufacturer')" class="form-text">
        {{ errors.first('manufacturer') }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t('active') }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="manufacturer.isActive">
        <label class="onoffswitch2-label" for="isActive">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t('save') }}
        </LoaderButton>
      </div>
    </div>

  </form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'ManufacturerForm',
  components: {
    LoaderButton
  },
  props: {
    manufacturer: {
      type: Object,
      default: () => ({
        name: '',
        isActive: true
      })
    }
  },
  computed: {
    ...mapState({
      manufacturers: state => state.manufacturer.all
    })
  },
  methods: {
    ...mapActions('manufacturer', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }
      const { id } = this.manufacturer
      let promise
      if (id) {
        promise = this.edit({ id, data: this.manufacturer })
      } else {
        promise = this.create(this.manufacturer)
      }
      const result = await promise
      if (result) {
        this.$router.push({ name: 'listmanufacturers' })
      }
    }
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
